import { Assessment } from '@teachur/http-client';

export const isAssessmentCorrect = (assessment: Assessment, userAnswerIds: number[]): boolean => {
  return (
    assessment.answers?.some(
      (answer) => userAnswerIds.includes(answer.id) && answer.correct === true
    ) ?? false
  );
};

export const findUserAnswerId = (assessment: Assessment, userAnswerIds: number[]): number => {
  return userAnswerIds.find((id) => assessment.answers?.some((a) => a.id === id)) ?? 0;
};
